import {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {isAppRoute} from '../shared/app-routes'

export const useMobileFirst = () => {
    const location = useLocation()
    const [mobileFirst, setMobileFirst] = useState(() => isAppRoute(location.pathname))
    useEffect(() => {
        setMobileFirst(isAppRoute(location.pathname))
    }, [location.pathname])
    return mobileFirst
}

